<template>
  <DefaultLayout
    :pageTitle="meta.title"
    :pageDescription="meta.description"
    :showFooterCTA="true"
  >
    <PageHeader
      title="Webinars"
      subtitle-text="Live sessions and on-demand replays on email, SMS and marketing automation — presented by the Transpond team."
      class="mb-0 no-submenu"
    ></PageHeader>

    <div class="container-fluid">
      <div class="row">
        <div class="col-xs-12">
          <div class="hub__grid mt-10 mb-20">
            <a class="hub__card" href="#" v-for="webinar in webinars" v-bind:key="webinar.title">
              <div class="hub__card-media hub__card-media--stone">
                <CardIllustration type="Webinar"></CardIllustration>
              </div>
              <div class="hub__card-body">
                <span
                  class="hub__card-type"
                  v-bind:class="webinar.status === 'Upcoming' ? 'hub__card-type--orange' : 'hub__card-type--stone'"
                >
                  {{ webinar.status }}
                </span>
                <p class="hub__card-title">{{ webinar.title }}</p>
                <div class="hub__card-meta">{{ webinar.meta }}</div>
              </div>
            </a>
          </div>
        </div>
      </div>
    </div>
  </DefaultLayout>
</template>

<script>
import DefaultLayout from "@/layouts/DefaultLayout";
import PageHeader from "@/components/Header/PageHeader";
import CardIllustration from "@/components/ContentHub/CardIllustration";

export default {
  name: "WebinarsPage",
  components: {
    DefaultLayout,
    PageHeader,
    CardIllustration,
  },
  data() {
    return {
      meta: {
        title: "Webinars",
        description:
          "Live sessions and on-demand replays on email, SMS and marketing automation — presented by the Transpond team.",
      },
      webinars: [
        { title: "Building high-converting email flows", status: "Upcoming", meta: "Oct 14, 2026 · 45 min" },
        { title: "Getting started with marketing automation", status: "On-demand", meta: "42 min" },
        { title: "Deliverability deep dive: SPF, DKIM & DMARC", status: "On-demand", meta: "38 min" },
        { title: "SMS + email: building a multichannel strategy", status: "On-demand", meta: "35 min" },
      ],
    };
  },
};
</script>
